import { useQuery } from 'react-query'
import axios from 'axios'
import { getApiServer } from '../../utils/helpers'

export default function useUsers () {
  return useQuery('users', async () => {
    const users = await axios.get(`${getApiServer()}/users`, { withCredentials: true })
    return users.data
  }, {
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 0,
    keepPreviousData: true,
    enabled: false
  })
}